<div class="ui left floated stacked badge {{ badge.badge_color }} circle">
    <div *ngIf="count && count > 1">&times; {{ count }}</div>
    <i class="fa {{ badge.icon_color }} {{ badge.icon }}"></i>
    <span [innerHtml]="badgeName"></span>
</div>
